import { render, staticRenderFns } from "./FbControll.vue?vue&type=template&id=8a77d1ee&scoped=true"
import script from "./FbControll.vue?vue&type=script&lang=js"
export * from "./FbControll.vue?vue&type=script&lang=js"
import style0 from "./FbControll.vue?vue&type=style&index=0&id=8a77d1ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a77d1ee",
  null
  
)

export default component.exports